module.exports = __webpack_public_path__ + "img/pauli-z-root-dagger-12.ce07048a.svg";